import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntidadService } from '../../../services/entidad.service';
import { EntidadDto } from '../../../dto/entidad/entidad.dto';
import { LanguageService } from '../../../services/util/language.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  entidadJustifacil: EntidadDto = {
    id: 0,
    entidad: '',
  };

  constructor(
    protected translateService: TranslateService,
    private entidadService: EntidadService,
    private languageService: LanguageService
  ) {
    this.entidadService.obtenerEntidadJustifacil().subscribe(response => {
      this.entidadJustifacil = response;
    });
  }

  public changeLanguage(): void {
    this.languageService.toggleLanguage();
  }
}
